<template>
  <v-layout row wrap>
    <v-flex xs12 sm8>
      <v-layout>
        <v-flex shrink>
          <div class="icon-select">
            <v-icon medium>group</v-icon>
          </div>
        </v-flex>
        <v-flex grow>
          <v-text-field
            label="Buscar"
            class="border-container"
            v-model="filters.search"
            prepend-inner-icon="search"
            clearable
            solo
            flat
            hide-details
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm4>
      <v-select
        :items="employeRoles"
        item-text="name"
        item-value="id"
        v-model="filters.webRoles"
        label="Rol"
        multiple
        class="border-container"
        solo
        flat
        hide-details
      />
    </v-flex>
    <v-flex xs12>
      <h3>Colaboradores</h3>
    </v-flex>
    <v-flex xs12>
      <v-data-table
        v-model="selected"
        select-all
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        :loading="loading"
        :rows-per-page-items="[25, 50, 100]"
        rows-per-page-text="Registros por página"
        no-results-text="No se encontraron coincidencias"
        no-data-text="No hay registros"
        :total-items="totalItems"
        ref="collaboratorTable"
      >
        <template v-slot:headers="props">
          <tr>
            <th style="text-align: left !important">
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="selectAll"
                color="primary"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :style="{ width: '33%' }"
              style="text-align: left !important"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
            :key="props.item.id"
            :active="props.selected"
            @click="props.selected = !props.selected"
          >
            <td style="text-align: left !important">
              <v-checkbox
                :input-value="props.selected"
                primary
                color="primary"
                hide-details
              ></v-checkbox>
            </td>
            <td :style="{ width: '33%' }" style="text-align: left !important">
              {{ props.item.firstName }}
            </td>
            <td :style="{ width: '33%' }" style="text-align: left !important">
              {{ props.item.lastName }}
            </td>
            <td :style="{ width: '33%' }" style="text-align: left !important">
              {{ props.item.role }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    selectedProp: {
      type: Array,
      default() {
        return [];
      },
    },
    extraItems: {
      type: Array,
      default() {
        return [];
      },
    },
    idSchedule: {
      type: Number
    },
  },
  data() {
    return {
      loading: false,
      selected: [],
      items: [],
      employeRoles: [],
      headers: [
        {
          text: "Nombre",
          value: "firstName",
          width: "33%",
          align: "left",
        },
        { text: "Apellido", value: "lastName", width: "33%", align: "left" },
        { text: "Rol", value: "role", width: "33%", align: "left" },
      ],
      totalItems: 0,
      pagination: {},
      filters: { search: "", webRoles: [] },
    };
  },
  methods: {
    selectAll() {
      if (this.$refs.collaboratorTable.someItems) {
        this.selected = this.selected.filter(({id}) =>
          !this.items.find(i=>i.id==id)
        );
      }
      else {
        // this.selected = [...this.extraItems]//, ...this.items];
        this.items.forEach(e => {
          if(this.selected.indexOf(e) === -1)
          this.selected.push(e)
        })
      }
    },
    listPendingEmploye(filters, pagination) {
      this.loading = true;
      const { webRoles, search } = filters;
      const query = new URLSearchParams();
      query.set("size", pagination.rowsPerPage);
      query.set("offset", (pagination.page - 1) * pagination.rowsPerPage);
      if (search) {
        query.set("search", search);
      }
      webRoles.forEach((element) => {
        query.append("webRoles", element);
      });

      const endpoint = this.idSchedule?
        `checker/listBelongAndPendingEmployee`:
        'checker/listPendingEmployee';

      this.$store
        .dispatch(endpoint, {
          idSchedule:this.idSchedule,
          query:query.toString()
        })
        .then((res) => {
            if(res.data && res.data.code === 1017) {
              this.$emit("onError", res.data);
              this.loading = false;
              return;
            }
      const extraItemsFiltered = pagination.page != 1?
      []:
       this.extraItems
        .filter(({ firstName, lastName }) => {
          if (!search) return true;
          return (
            firstName
              .toString()
              .toLocaleLowerCase()
              .indexOf(search.toLocaleLowerCase()) !== -1 ||
            lastName
              .toString()
              .toLocaleLowerCase()
              .indexOf(search.toLocaleLowerCase()) !== -1
          );
        })
        .filter(({ role }) => {
          const releId = (
            this.employeRoles.find((i) => i.name === role) || {}
          ).id;

          if (webRoles.length && releId) {
            return webRoles.includes(releId);
          }
          return true;
        });
          this.items = [...res.data.list];
          this.totalItems = res.data.total;
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    listEmployeRols() {
      this.$store
        .dispatch("employee/getTools")
        .then((response) => {
          this.employeRoles = response.data.entity.roles;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  }, 
  mounted() {
    // this.listPendingEmploye(this.filters, this.pagination);
    this.listEmployeRols();
  },
  watch: {
    selectedProp() {
      // NOTE :
      // BE CAREFUL THIS CONDITION CAN PROVOKE AN INFINITE LOOP IF IS REMOVED
      if (
        this.selectedProp != this.selected &&
        this.selectedProp.length != this.selected.length
      ) {
        this.selected = this.selectedProp.slice();
      }
    },
    selected() {
      this.$emit("onSelect", this.selected);
    },
    pagination: {
      handler() {
        this.listPendingEmploye(this.filters, this.pagination);
      },
      deep: true,
    },
    filters: {
      handler() {
        this.listPendingEmploye(this.filters, this.pagination);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.icon-select {
  padding: 8px;
  display: inline-block;
  background-color: rgba(195, 155, 211, 0.8);
  border-radius: 0.5rem;
}

/deep/ .v-datatable.v-table > tbody {
	max-height: 35vh;
	min-height: 35vh;
}
</style>